module.exports = __webpack_public_path__ + "img/bgTitle6.3ebbba0a.png";